import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import config from '../../../config';

export interface IUpgradeRequest {
  project_name: string;
  technology: string;
  current_version: string;
  target_version: string;
}

export interface IUpgradeResponse {
  status: string;
  message: string;
  link: string;
}

@Injectable({
  providedIn: 'root',
})
export class UpgradeService {
  private apiUrl = config.API_GATEWAY_ENDPOINT;

  constructor(private http: HttpClient) {}

  triggerUpgrade(payload: IUpgradeRequest): any {
    console.log(payload);

    lastValueFrom(
      this.http.post<IUpgradeResponse>(
        `${this.apiUrl}/trigger-upgrade`,
        payload,
      ),
    );
  }
}
